import { t } from 'i18next';
import { InputMask, InputMaskChangeEvent } from 'primereact/inputmask';
import { Tooltip } from 'primereact/tooltip';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/app/hooks';
import { ChuteSchedulerActions } from '@/app/slices/chuteScheduler';

type Props = { className?: string };

export const StartTime = ({ className }: Props) => {
  const dispatch = useDispatch();
  const { startTime } = useAppSelector((s) => s.chuteScheduler);

  const uiValue = (() => {
    if (!startTime) return '';
    const hh24 = +startTime.slice(0, 2);
    const mm = startTime.slice(2);
    const mer = hh24 < 12 ? 'AM' : 'PM';
    const hh12 = ((hh24 + 11) % 12) + 1;
    return `${String(hh12).padStart(2, '0')}:${mm} ${mer}`;
  })();

  const mask = '99:99 aa';
  const regex = /^(0?[1-9]|1[0-2]):[0-5]\d\s?(AM|PM)$/i;

  const to24h = (val: string) => {
    const [, hh, mm, mer] = val.match(/(\d{1,2}):(\d{2})\s?(AM|PM)/i) || [];
    if (!hh) return '';
    let h = Number(hh) % 12;
    if (mer.toUpperCase() === 'PM') h += 12;
    return `${String(h).padStart(2, '0')}${mm}`;
  };

  const handleChange = (e: InputMaskChangeEvent) => {
    const val = e.value?.toUpperCase() ?? '';
    if (regex.test(val)) {
      dispatch({
        type: ChuteSchedulerActions.UPDATE_START_TIME,
        startTime: to24h(val),
      });
    }
  };

  return (
    <div
      className={`${className ?? ''} label-input-group flex flex-col gap-1`.trim()}
    >
      <Tooltip
        target=".start-time-help"
        position="top"
        content="Start time for the first aspiration. Use 12‑hour format (hh:mm AM/PM)."
        className="max-w-xs"
      />

      <div className="flex items-center gap-1">
        <label>{t('chuteScheduler.startTime')}</label>
        <i className="pi pi-info-circle start-time-help cursor-help text-gray-400" />
      </div>

      <InputMask
        mask={mask}
        placeholder="hh:mm AM"
        slotChar="0"
        value={uiValue}
        ref={(el) => {
          if (el) {
            (el as any).inputmask?.updateOptions({
              definitions: {
                a: /[APapmM]/,
              },
            });
          }
        }}
        onChange={handleChange}
        invalid={!!uiValue && !regex.test(uiValue)}
        className="h-10 w-full lg:w-28"
      />
    </div>
  );
};
